import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMatchLoading, loadMatchAndEvents } from '../reducers/match';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import FootballLiveMatch from '../components/FootballLiveMatch';

const REFRESH_INTERVAL_MILLIS = 10000;

@layoutAsyncConnect(
  'FootballLiveMatchContainer',
  [{
    dispatch: ({ params: { matchId }, getState }) => {
      const {
        football: {
          match: {
            [matchId]: {
              last_modified_date
            } = {}
          } = {}
        } = {}
      } = getState() || {};
      return loadMatchAndEvents(matchId, last_modified_date);
    },
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    preventResolve: ({state, params: {matchId}}) => isMatchLoading(state, matchId),
    state: state => ({match: state.football.match})
  }]
)
@catchLifeCycleErrors
export default class FootballLiveMatchContainer extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    match: PropTypes.object,
    params: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.object
  }

  render() {
    return (
      <FootballLiveMatch
        match={this.props.match[this.props.params.matchId].match}
        matchId={this.props.params.matchId}
        events={this.props.match[this.props.params.matchId].events}
        children={this.props.children}
        routes={this.props.routes}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveMatchContainer.js